module.exports = __webpack_public_path__ + "img/wedcr9.81134dae.jpg";